const isMobileDevice = () => navigator.maxTouchPoints > 0 && window.screen.width <= 768;

export default isMobileDevice;
